import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

export const ROLES = {
  ADMIN: 'admin',
  APP_EDITOR: 'app_editor',
  USER: 'user',
} as const;

export type Role = typeof ROLES[keyof typeof ROLES];

export const useAuthorization = () => {
  const { user } = useContext(AuthContext);

  const hasRole = (role: Role | Role[]) => {
    if (!user || !user.roles) return false;
    
    const roles = Array.isArray(role) ? role : [role];
    return roles.some(r => user.roles.includes(r));
  };

  const canManageCourses = () => {
    return hasRole([ROLES.ADMIN, ROLES.APP_EDITOR]);
  };

  const canManageLessons = () => {
    return hasRole([ROLES.ADMIN, ROLES.APP_EDITOR]);
  };

  return {
    hasRole,
    canManageCourses,
    canManageLessons,
  };
}; 